"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogCategory = exports.Log = void 0;
var interfaces_1 = require("@augloop/interfaces");
var serviceName = ((typeof process != 'undefined') && process.env) ? process.env.SERVICE_NAME : 'client';
var symbolSpace = 'abcdefghijklmnopqrstuvwxyz0123456789';
var symbolSpaceLookup = {
    97: 0,
    98: 1,
    99: 2,
    100: 3,
    101: 4,
    102: 5,
    103: 6,
    104: 7,
    105: 8,
    106: 9,
    107: 10,
    108: 11,
    109: 12,
    110: 13,
    111: 14,
    112: 15,
    113: 16,
    114: 17,
    115: 18,
    116: 19,
    117: 20,
    118: 21,
    119: 22,
    120: 23,
    121: 24,
    122: 25,
    48: 26,
    49: 27,
    50: 28,
    51: 29,
    52: 30,
    53: 31,
    54: 32,
    55: 33,
    56: 34,
    57: 35
};
var loggers = [];
var getCorrelation;
var aggregators = new Map();
var loggersByLevel = new Map();
var overridenTags = new Map();
var Log;
(function (Log) {
    Log.defineCoreLogCategory = function (name) {
        return { root: 'Core', name: name };
    };
    Log.defineWorkflowLogCategory = function (name) {
        return { root: 'Workflow', name: name };
    };
    Log.clearLoggers = function () {
        loggers = [];
        loggersByLevel.clear();
    };
    Log.addLogger = function (logger) {
        loggers.push(logger);
        Object.keys(interfaces_1.LoggingLevel)
            .map(function (level) { return interfaces_1.LoggingLevel[level]; })
            .filter(function (level) { return level <= logger.level; })
            .forEach(function (level) {
            if (!loggersByLevel.has(level)) {
                loggersByLevel.set(level, [logger]);
            }
            else {
                loggersByLevel.get(level)
                    .push(logger);
            }
        });
    };
    Log.setCorrelationContextCallback = function (cb) {
        getCorrelation = cb;
    };
    Log.addAggregator = function (aggregator) {
        aggregator.init(function (obj, isAggregated) {
            logToLoggers(obj, isAggregated);
        });
        aggregators.set(aggregator.eventName, aggregator);
    };
    Log.flushAggregators = function (stop) {
        aggregators.forEach(function (aggregator) {
            aggregator.flush(stop);
        });
    };
    Log.setTagLevelOverride = function (tag, level) {
        var tagId = tagStringToId(tag);
        overridenTags.set(tagId, level);
    };
    Log.resetTagLevelOverrides = function () {
        overridenTags.clear();
    };
    Log.error = function (tagId, logCategory) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        log(tagId, logCategory, interfaces_1.LoggingLevel.error, args);
    };
    Log.warn = function (tagId, logCategory) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        log(tagId, logCategory, interfaces_1.LoggingLevel.warn, args);
    };
    Log.info = function (tagId, logCategory) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        log(tagId, logCategory, interfaces_1.LoggingLevel.info, args);
    };
    Log.verbose = function (tagId, logCategory) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        log(tagId, logCategory, interfaces_1.LoggingLevel.verbose, args);
    };
    Log.debug = function (tagId, logCategory) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        log(tagId, logCategory, interfaces_1.LoggingLevel.debug, args);
    };
    Log.metric = function (tagId, logCategory) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        log(tagId, logCategory, interfaces_1.LoggingLevel.metric, args);
    };
    Log.dynamic = function (obj) {
        logToLoggers(obj);
    };
})(Log = exports.Log || (exports.Log = {}));
var unfoldArgs = function (args) {
    return args.map(function (arg) {
        return typeof arg === 'function' ? arg() : arg;
    });
};
var argsToString = function (args) {
    return args.map(function (arg) {
        if (arg instanceof Error) {
            return JSON.stringify({
                message: arg.message,
                name: arg.name,
                stack: arg.stack
            });
        }
        if (typeof arg === 'object') {
            return JSON.stringify(arg);
        }
        return arg;
    }).join(' ');
};
var getLoggers = function (level) {
    if (level !== undefined) {
        return loggersByLevel.get(level) || [];
    }
    return loggers;
};
var log = function (tagId, category, level, args) {
    // Expensive log statements will be logged with () => '' syntax and should not be unnecessarily unfolded.
    level = overridenTags.get(tagId) || level;
    var loggers = getLoggers(level);
    if (loggers.length == 0) {
        return;
    }
    var tag = tagIdToString(tagId);
    var unfoldedArgs = unfoldArgs(args);
    if (unfoldedArgs.length == 1 && typeof unfoldedArgs[0] === 'object') {
        var obj = unfoldedArgs[0];
        obj.tagId = tag;
        if (obj.eventName === 'Operation' && category.root === 'Workflow') {
            obj.eventName = 'WorkflowOperation';
        }
        obj.traceLevel = level;
        var aggregator = aggregators.get(obj.eventName);
        if (aggregator) {
            aggregator.add(obj);
        }
        else {
            logToLoggers(obj, false, loggers);
        }
    }
    else {
        logToLoggers({
            eventName: 'Log',
            tagId: tag,
            category: category.root + "." + category.name,
            traceLevel: level,
            message: argsToString(unfoldedArgs)
        }, false, loggers);
    }
};
var logToLoggers = function (obj, isAggregated, loggers) {
    var _a, _b, _c;
    if (isAggregated === void 0) { isAggregated = false; }
    if (loggers == null) {
        loggers = getLoggers(obj.traceLevel);
    }
    if (loggers.length > 0) {
        obj.serviceName = serviceName;
        if (!isAggregated && getCorrelation) {
            var correlation = getCorrelation();
            if (correlation) {
                obj.cv = obj.cv ? obj.cv : correlation.cv.toString();
                obj.sessionKey = obj.sessionKey ? obj.sessionKey : correlation.sessionKey;
                obj.workflow = obj.workflow ? obj.workflow : correlation.workflow;
                /*
                 * Some incoming objects already include separate clientMetadata fields (i.e. clientAppName).
                 * Adding the whole clientMetadata would increase the log size and also cause a cardinality explosion,
                 * as some fields are long, and other high-cardinality.
                 *
                 * Only add short, low cardinality fields to logs.
                 */
                var clientAppName = (_a = correlation.clientMetadata) === null || _a === void 0 ? void 0 : _a.appName;
                obj.clientAppName = obj.clientAppName ? obj.clientAppName : clientAppName;
                var clientAppPlatform = (_b = correlation.clientMetadata) === null || _b === void 0 ? void 0 : _b.appPlatform;
                obj.clientAppPlatform = obj.clientAppPlatform ? obj.clientAppPlatform : clientAppPlatform;
                var clientReleaseAudienceGroup = (_c = correlation.clientMetadata) === null || _c === void 0 ? void 0 : _c.releaseAudienceGroup;
                obj.clientReleaseAudienceGroup = obj.clientReleaseAudienceGroup ? obj.clientReleaseAudienceGroup : clientReleaseAudienceGroup;
            }
        }
        for (var _i = 0, loggers_1 = loggers; _i < loggers_1.length; _i++) {
            var logger = loggers_1[_i];
            logger.log(obj);
        }
    }
};
var tagIdToString = function (tagId) {
    return symbolSpace[(tagId >> 24) & 0x3F]
        + symbolSpace[(tagId >> 18) & 0x3F]
        + symbolSpace[(tagId >> 12) & 0x3F]
        + symbolSpace[(tagId >> 6) & 0x3F]
        + symbolSpace[(tagId >> 0) & 0x3F];
};
var tagStringToId = function (tag) {
    if (tag && tag.length === 5) {
        return (symbolSpaceLookup[tag.charCodeAt(0)] << 24
            | symbolSpaceLookup[tag.charCodeAt(1)] << 18
            | symbolSpaceLookup[tag.charCodeAt(2)] << 12
            | symbolSpaceLookup[tag.charCodeAt(3)] << 6
            | symbolSpaceLookup[tag.charCodeAt(4)]);
    }
    return -1;
};
var LogCategory = /** @class */ (function () {
    function LogCategory() {
    }
    LogCategory.CoreDefault = Log.defineCoreLogCategory('Default');
    LogCategory.WorkflowDefault = Log.defineWorkflowLogCategory('Default');
    return LogCategory;
}());
exports.LogCategory = LogCategory;
//# sourceMappingURL=logging.js.map